import { ThemeColor } from 'utils/colors'

export type IconVariant = 'info' | 'success' | 'error' | 'warning' | 'successPurple'

type Variant = {
  color: ThemeColor
  icon: string[]
  name: string
}

export const iconVariant: Record<IconVariant, Variant> = {
  info: {
    color: 'blue2',
    icon: ['far', 'info-circle'],
    name: 'info',
  },
  successPurple: {
    color: 'purple1',
    icon: ['far', 'check-circle'],
    name: 'success',
  },
  success: {
    color: 'green2',
    icon: ['far', 'check-circle'],
    name: 'success',
  },
  error: {
    color: 'red',
    icon: ['far', 'times-circle'],
    name: 'error',
  },
  warning: {
    color: 'yellow',
    icon: ['far', 'exclamation-triangle'],
    name: 'warning',
  },
}
